import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/bgi.png'
import _imports_1 from '../assets/img/b.png'
import _imports_2 from '../assets/img/Gr1.png'
import _imports_3 from '../assets/img/Gr2.png'
import _imports_4 from '../assets/img/Gr3.png'
import _imports_5 from '../assets/img/Gr4.png'
import _imports_6 from '../assets/img/Gr5.png'
import _imports_7 from '../assets/img/o.png'
import _imports_8 from '../assets/img/Ellipse122.png'
import _imports_9 from '../assets/img/bgi2.png'
import _imports_10 from '../assets/img/Group3.png'
import _imports_11 from '../assets/img/Group4.png'
import _imports_12 from '../assets/img/Group5.png'
import _imports_13 from '../assets/img/Group6.png'
import _imports_14 from '../assets/img/Group7.png'
import _imports_15 from '../assets/img/Group8.png'
import _imports_16 from '../assets/img/Group9.png'
import _imports_17 from '../assets/img/Group10.png'
import _imports_18 from '../assets/img/Group11.png'
import _imports_19 from '../assets/img/Maskgroup.png'
import _imports_20 from '../assets/img/s.png'


const _withScopeId = n => (_pushScopeId("data-v-4f810a51"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "home",
  ref: "autofitContainer",
  style: {"overflow":"hidden"}
}
const _hoisted_2 = {
  class: "custom-slick-arrow",
  style: {"left":"6%","z-index":"1"}
}
const _hoisted_3 = {
  class: "custom-slick-arrow",
  style: {"right":"6%"}
}
const _hoisted_4 = { href: "/list/product" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  class: "custom-slick-arrow",
  style: {"left":"6%","z-index":"1"}
}
const _hoisted_7 = {
  class: "custom-slick-arrow",
  style: {"right":"6%"}
}
const _hoisted_8 = { style: {"height":"calc(30vh - 60px) !important","display":"flex","align-items":"center"} }
const _hoisted_9 = { href: "/list/product" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { style: {"width":"100vw","height":"auto","position":"relative"} }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"100%","height":"100%","position":"absolute","top":"0","left":"0"},
  alt: ""
}, null, -1))
const _hoisted_13 = {
  key: 0,
  class: "content_box ywfw"
}
const _hoisted_14 = { class: "home_container" }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"module_tit_box\" style=\"display:flex;justify-content:space-between;align-items:center;\" data-v-4f810a51><div class=\"module_title\" style=\"position:relative;margin-top:100px;\" data-v-4f810a51><img src=\"" + _imports_1 + "\" style=\"width:80px;height:102px;position:absolute;top:-72px;left:0px;\" alt=\"\" data-v-4f810a51><span style=\"position:absolute;z-index:1;display:block;font-size:28px;font-weight:600;color:#000 !important;\" data-v-4f810a51>业务服务</span><span style=\"display:block;font-size:28px;font-weight:600;color:#000 !important;opacity:0;\" data-v-4f810a51>业务服务</span><span style=\"display:block;color:#999 !important;font-size:22px;font-weight:600;\" data-v-4f810a51>Business Services</span></div><div class=\"module_subTitle\" style=\"margin-top:80px;\" data-v-4f810a51>客户需要什么，我们就开发什么</div></div>", 1)
const _hoisted_16 = {
  class: "ywfw_box",
  style: {"width":"1400px","margin-left":"-80px"}
}
const _hoisted_17 = { class: "image-container" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "image-wrapper" }
const _hoisted_20 = ["src"]
const _hoisted_21 = { href: "/list/product" }
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 1,
  class: "content_box ywfw"
}
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<div class=\"home_container\" data-v-4f810a51><div class=\"module_tit_box\" style=\"display:flex;justify-content:space-between;align-items:center;\" data-v-4f810a51><div class=\"module_title\" style=\"position:relative;margin-top:70px;\" data-v-4f810a51><img src=\"" + _imports_1 + "\" style=\"width:45px;height:62px;position:absolute;top:-39px;left:0px;\" alt=\"\" data-v-4f810a51><span style=\"position:absolute;z-index:1;display:block;font-size:18px;font-weight:600;color:#000 !important;\" data-v-4f810a51>业务服务</span><span style=\"display:block;font-size:14px;font-weight:600;color:#000 !important;opacity:0;\" data-v-4f810a51>业务服务</span><span style=\"display:block;color:#999 !important;font-size:14px;font-weight:600;\" data-v-4f810a51>Business Services</span></div></div><div class=\"\" style=\"display:flex;flex-direction:row;align-items:center;flex-wrap:wrap;justify-content:center;position:relative;z-index:9;\" data-v-4f810a51><div class=\"figure\" style=\"margin-left:10px;\" data-v-4f810a51><a href=\"/list/product\" data-v-4f810a51><img src=\"" + _imports_2 + "\" style=\"width:100px;height:100px;\" class=\"fangda figure-img img-fluid rounded\" alt=\"工程行业\" data-v-4f810a51></a></div><div class=\"figure\" style=\"margin-left:10px;\" data-v-4f810a51><a href=\"/list/product\" data-v-4f810a51><img src=\"" + _imports_3 + "\" style=\"width:100px;height:100px;\" class=\"fangda figure-img img-fluid rounded\" alt=\"物联网应用\" data-v-4f810a51></a></div><div class=\"figure\" style=\"margin-left:10px;\" data-v-4f810a51><a href=\"/list/product\" data-v-4f810a51><img src=\"" + _imports_4 + "\" style=\"width:100px;height:100px;\" class=\"fangda figure-img img-fluid rounded\" alt=\"中小企业信息化服务\" data-v-4f810a51></a></div><div class=\"figure\" style=\"margin-left:10px;\" data-v-4f810a51><a href=\"/list/product\" data-v-4f810a51><img src=\"" + _imports_5 + "\" style=\"width:100px;height:100px;\" class=\"fangda figure-img img-fluid rounded\" alt=\"互联网应用\" data-v-4f810a51></a></div><div class=\"figure\" style=\"margin-left:10px;\" data-v-4f810a51><a href=\"/list/product\" data-v-4f810a51><img src=\"" + _imports_6 + "\" style=\"width:100px;height:100px;\" class=\"fangda figure-img img-fluid rounded\" alt=\"行业软件定制开发\" data-v-4f810a51></a></div></div></div>", 1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 2,
  class: "content_box ywfw"
}
const _hoisted_27 = /*#__PURE__*/_createStaticVNode("<div class=\"home_container\" data-v-4f810a51><div class=\"module_tit_box\" style=\"display:flex;justify-content:space-between;align-items:center;\" data-v-4f810a51><div class=\"module_title\" style=\"position:relative;margin-top:100px;\" data-v-4f810a51><img src=\"" + _imports_1 + "\" style=\"width:80px;height:102px;position:absolute;top:-72px;left:0px;\" alt=\"\" data-v-4f810a51><span style=\"position:absolute;z-index:1;display:block;font-size:28px;font-weight:600;color:#000 !important;\" data-v-4f810a51>业务服务</span><span style=\"display:block;font-size:28px;font-weight:600;color:#000 !important;opacity:0;\" data-v-4f810a51>业务服务</span><span style=\"display:block;color:#999 !important;font-size:22px;font-weight:600;\" data-v-4f810a51>Business Services</span></div></div><div class=\"\" style=\"display:flex;flex-direction:row;align-items:center;flex-wrap:wrap;justify-content:center;position:relative;z-index:9;\" data-v-4f810a51><div class=\"figure\" style=\"margin-right:20px;\" data-v-4f810a51><a href=\"/list/product\" data-v-4f810a51><img src=\"" + _imports_2 + "\" style=\"width:230px;height:230px;\" class=\"fangda figure-img img-fluid rounded\" alt=\"工程行业\" data-v-4f810a51></a></div><div class=\"figure\" style=\"margin-right:20px;\" data-v-4f810a51><a href=\"/list/product\" data-v-4f810a51><img src=\"" + _imports_3 + "\" style=\"width:230px;height:230px;\" class=\"fangda figure-img img-fluid rounded\" alt=\"物联网应用\" data-v-4f810a51></a></div><div class=\"figure\" style=\"margin-right:20px;\" data-v-4f810a51><a href=\"/list/product\" data-v-4f810a51><img src=\"" + _imports_4 + "\" style=\"width:230px;height:230px;\" class=\"fangda figure-img img-fluid rounded\" alt=\"中小企业信息化服务\" data-v-4f810a51></a></div><div class=\"figure\" style=\"margin-right:20px;\" data-v-4f810a51><a href=\"/list/product\" data-v-4f810a51><img src=\"" + _imports_5 + "\" style=\"width:230px;height:230px;\" class=\"fangda figure-img img-fluid rounded\" alt=\"互联网应用\" data-v-4f810a51></a></div><div class=\"figure\" style=\"margin-right:20px;\" data-v-4f810a51><a href=\"/list/product\" data-v-4f810a51><img src=\"" + _imports_6 + "\" style=\"width:230px;height:230px;\" class=\"fangda figure-img img-fluid rounded\" alt=\"行业软件定制开发\" data-v-4f810a51></a></div></div></div>", 1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 3,
  class: "content_box dzlc"
}
const _hoisted_30 = { class: "home_container" }
const _hoisted_31 = /*#__PURE__*/_createStaticVNode("<div class=\"module_tit_box\" style=\"display:flex;justify-content:space-between;align-items:center;\" data-v-4f810a51><div class=\"module_title\" style=\"position:relative;margin-top:100px;\" data-v-4f810a51><img src=\"" + _imports_7 + "\" style=\"width:80px;height:102px;position:absolute;top:-72px;left:0px;\" alt=\"\" data-v-4f810a51><span style=\"position:absolute;z-index:1;display:block;font-size:28px;font-weight:600;color:#000 !important;\" data-v-4f810a51>业务流程</span><span style=\"display:block;font-size:28px;font-weight:600;color:#000 !important;opacity:0;\" data-v-4f810a51>业务服务</span><span style=\"display:block;color:#999 !important;font-size:22px;font-weight:600;\" data-v-4f810a51>operation flow</span></div><div class=\"module_subTitle\" style=\"margin-top:80px;\" data-v-4f810a51>用专业技术和服务，为客户创造价值</div></div>", 1)
const _hoisted_32 = { class: "process-flow-container" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "process-background" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_8,
    alt: "背景"
  })
], -1))
const _hoisted_34 = { class: "process-steps" }
const _hoisted_35 = ["src", "alt"]
const _hoisted_36 = {
  key: 4,
  class: "content_box dzlc"
}
const _hoisted_37 = { class: "home_container" }
const _hoisted_38 = /*#__PURE__*/_createStaticVNode("<div class=\"module_tit_box\" style=\"display:flex;justify-content:space-between;align-items:center;\" data-v-4f810a51><div class=\"module_title\" style=\"position:relative;margin-top:70px;\" data-v-4f810a51><img src=\"" + _imports_7 + "\" style=\"width:45px;height:62px;position:absolute;top:-39px;left:0px;\" alt=\"\" data-v-4f810a51><span style=\"position:absolute;z-index:1;display:block;font-size:18px;font-weight:600;color:#000 !important;\" data-v-4f810a51>业务流程</span><span style=\"display:block;font-size:14px;font-weight:600;color:#000 !important;opacity:0;\" data-v-4f810a51>业务服务</span><span style=\"display:block;color:#999 !important;font-size:14px;font-weight:600;\" data-v-4f810a51>operation flow</span></div></div>", 1)
const _hoisted_39 = {
  class: "dzlc_box",
  sty: ""
}
const _hoisted_40 = ["width", "height"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z" }, null, -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = {
  key: 2,
  class: "content_box xcdt",
  style: {"position":"relative","padding":"50px 0"}
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  style: {"width":"100%","height":"100%","position":"absolute","top":"0","left":"0"},
  alt: ""
}, null, -1))
const _hoisted_45 = {
  class: "home_container",
  style: {"width":"100vw"}
}
const _hoisted_46 = {
  key: 0,
  class: "module_tit_box",
  style: {"display":"flex","justify-content":"space-between","align-items":"center","width":"1250px","margin":"0 auto"}
}
const _hoisted_47 = /*#__PURE__*/_createStaticVNode("<div class=\"module_title\" style=\"position:relative;margin-top:100px;\" data-v-4f810a51><img src=\"" + _imports_7 + "\" style=\"width:80px;height:102px;position:absolute;top:-72px;left:0px;\" alt=\"\" data-v-4f810a51><span style=\"position:absolute;z-index:1;display:block;font-size:28px;font-weight:600;color:#fff !important;\" data-v-4f810a51>现场动态</span><span style=\"display:block;font-size:28px;font-weight:600;color:#000 !important;opacity:0;\" data-v-4f810a51>现场动态</span><span style=\"display:block;color:#999 !important;font-size:22px;font-weight:600;\" data-v-4f810a51>On site dynamics</span></div><div class=\"module_subTitle\" style=\"margin-top:80px;color:#fff !important;z-index:1;\" data-v-4f810a51> 用专业技术和服务，为客户创造价值 </div>", 2)
const _hoisted_49 = [
  _hoisted_47
]
const _hoisted_50 = {
  key: 1,
  class: "module_tit_box",
  style: {"display":"flex","justify-content":"space-between","align-items":"center","width":"100%","margin":"0 auto","padding":"0 10%"}
}
const _hoisted_51 = /*#__PURE__*/_createStaticVNode("<div class=\"module_title\" style=\"position:relative;margin-top:100px;\" data-v-4f810a51><img src=\"" + _imports_7 + "\" style=\"width:80px;height:102px;position:absolute;top:-72px;left:0px;\" alt=\"\" data-v-4f810a51><span style=\"position:absolute;z-index:1;display:block;font-size:28px;font-weight:600;color:#fff !important;\" data-v-4f810a51>现场动态</span><span style=\"display:block;font-size:28px;font-weight:600;color:#000 !important;opacity:0;\" data-v-4f810a51>现场动态</span><span style=\"display:block;color:#999 !important;font-size:22px;font-weight:600;\" data-v-4f810a51>On site dynamics</span></div>", 1)
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = {
  key: 2,
  class: "module_tit_box",
  style: {"display":"flex","justify-content":"space-between","align-items":"center","width":"100%","margin":"0 auto","padding":"0 10%"}
}
const _hoisted_54 = /*#__PURE__*/_createStaticVNode("<div class=\"module_title\" style=\"position:relative;margin-top:100px;\" data-v-4f810a51><img src=\"" + _imports_7 + "\" style=\"width:80px;height:102px;position:absolute;top:-72px;left:0px;\" alt=\"\" data-v-4f810a51><span style=\"position:absolute;z-index:1;display:block;font-size:28px;font-weight:600;color:#fff !important;\" data-v-4f810a51>现场动态</span><span style=\"display:block;font-size:28px;font-weight:600;color:#000 !important;opacity:0;\" data-v-4f810a51>现场动态</span><span style=\"display:block;color:#999 !important;font-size:22px;font-weight:600;\" data-v-4f810a51>On site dynamics</span></div>", 1)
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = {
  class: "xcdt_box",
  style: {"margin-top":"50px"}
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  alt: ""
}, null, -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_11,
  alt: ""
}, null, -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_12,
  alt: ""
}, null, -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_13,
  alt: ""
}, null, -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_14,
  alt: ""
}, null, -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_15,
  alt: ""
}, null, -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_16,
  alt: ""
}, null, -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_17,
  alt: ""
}, null, -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_18,
  alt: ""
}, null, -1))
const _hoisted_66 = {
  key: 3,
  class: "xcdt_box",
  style: {"margin-bottom":"50px"}
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  alt: ""
}, null, -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_11,
  alt: ""
}, null, -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_12,
  alt: ""
}, null, -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_13,
  alt: ""
}, null, -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_14,
  alt: ""
}, null, -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_15,
  alt: ""
}, null, -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_16,
  alt: ""
}, null, -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_17,
  alt: ""
}, null, -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_18,
  alt: ""
}, null, -1))
const _hoisted_76 = {
  key: 3,
  class: "content_box xcdt",
  style: {"position":"relative","padding":"50px 0"}
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  style: {"width":"100%","height":"100%","position":"absolute","top":"0","left":"0"},
  alt: ""
}, null, -1))
const _hoisted_78 = {
  class: "home_container",
  style: {"width":"100vw"}
}
const _hoisted_79 = {
  key: 0,
  class: "module_tit_box",
  style: {"display":"flex","justify-content":"space-between","align-items":"center","width":"1250px","margin":"0 auto"}
}
const _hoisted_80 = /*#__PURE__*/_createStaticVNode("<div class=\"module_title\" style=\"position:relative;margin-top:100px;\" data-v-4f810a51><img src=\"" + _imports_7 + "\" style=\"width:80px;height:102px;position:absolute;top:-72px;left:0px;\" alt=\"\" data-v-4f810a51><span style=\"position:absolute;z-index:1;display:block;font-size:28px;font-weight:600;color:#fff !important;\" data-v-4f810a51>现场动态</span><span style=\"display:block;font-size:28px;font-weight:600;color:#000 !important;opacity:0;\" data-v-4f810a51>现场动态</span><span style=\"display:block;color:#999 !important;font-size:22px;font-weight:600;\" data-v-4f810a51>On site dynamics</span></div><div class=\"module_subTitle\" style=\"margin-top:80px;color:#fff !important;z-index:1;\" data-v-4f810a51> 用专业技术和服务，为客户创造价值 </div>", 2)
const _hoisted_82 = [
  _hoisted_80
]
const _hoisted_83 = {
  key: 1,
  class: "module_tit_box",
  style: {"display":"flex","justify-content":"space-between","align-items":"center","width":"100%","margin":"0 auto","padding":"0 10%"}
}
const _hoisted_84 = /*#__PURE__*/_createStaticVNode("<div class=\"module_title\" style=\"position:relative;margin-top:70px;\" data-v-4f810a51><img src=\"" + _imports_7 + "\" style=\"width:45px;height:62px;position:absolute;top:-39px;left:0px;\" alt=\"\" data-v-4f810a51><span style=\"position:absolute;z-index:1;display:block;font-size:18px;font-weight:600;color:#fff !important;\" data-v-4f810a51>现场动态</span><span style=\"display:block;font-size:14px;font-weight:600;color:#000 !important;opacity:0;\" data-v-4f810a51>现场动态</span><span style=\"display:block;color:#999 !important;font-size:14px;font-weight:600;\" data-v-4f810a51>On site dynamics</span></div>", 1)
const _hoisted_85 = [
  _hoisted_84
]
const _hoisted_86 = {
  key: 2,
  class: "module_tit_box",
  style: {"display":"flex","justify-content":"space-between","align-items":"center","width":"100%","margin":"0 auto","padding":"0 10%"}
}
const _hoisted_87 = /*#__PURE__*/_createStaticVNode("<div class=\"module_title\" style=\"position:relative;margin-top:100px;\" data-v-4f810a51><img src=\"" + _imports_7 + "\" style=\"width:80px;height:102px;position:absolute;top:-72px;left:0px;\" alt=\"\" data-v-4f810a51><span style=\"position:absolute;z-index:1;display:block;font-size:28px;font-weight:600;color:#fff !important;\" data-v-4f810a51>现场动态</span><span style=\"display:block;font-size:28px;font-weight:600;color:#000 !important;opacity:0;\" data-v-4f810a51>现场动态</span><span style=\"display:block;color:#999 !important;font-size:22px;font-weight:600;\" data-v-4f810a51>On site dynamics</span></div>", 1)
const _hoisted_88 = [
  _hoisted_87
]
const _hoisted_89 = {
  class: "xcdt_box",
  style: {"margin-top":"50px"}
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"80px","height":"80px"},
  src: _imports_10,
  alt: ""
}, null, -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"80px","height":"80px"},
  src: _imports_11,
  alt: ""
}, null, -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"80px","height":"80px"},
  src: _imports_12,
  alt: ""
}, null, -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"80px","height":"80px"},
  src: _imports_13,
  alt: ""
}, null, -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"80px","height":"80px"},
  src: _imports_14,
  alt: ""
}, null, -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"80px","height":"80px"},
  src: _imports_15,
  alt: ""
}, null, -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"80px","height":"80px"},
  src: _imports_16,
  alt: ""
}, null, -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"80px","height":"80px"},
  src: _imports_17,
  alt: ""
}, null, -1))
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"80px","height":"80px"},
  src: _imports_18,
  alt: ""
}, null, -1))
const _hoisted_99 = {
  key: 4,
  class: "content_box zlhz",
  style: {"position":"relative"}
}
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_19,
  style: {"width":"100%","height":"100%","position":"absolute","top":"0","left":"0"},
  alt: ""
}, null, -1))
const _hoisted_101 = { class: "home_container" }
const _hoisted_102 = /*#__PURE__*/_createStaticVNode("<div class=\"module_tit_box\" style=\"display:flex;justify-content:space-between;align-items:center;\" data-v-4f810a51><div class=\"module_title\" style=\"position:relative;margin-top:100px;\" data-v-4f810a51><img src=\"" + _imports_20 + "\" style=\"width:80px;height:102px;position:absolute;top:-72px;left:0px;\" alt=\"\" data-v-4f810a51><span style=\"position:absolute;z-index:1;display:block;font-size:28px;font-weight:600;color:#000 !important;\" data-v-4f810a51>战略合作</span><span style=\"display:block;font-size:28px;font-weight:600;color:#000 !important;opacity:0;\" data-v-4f810a51>战略合作</span><span style=\"display:block;color:#999 !important;font-size:22px;font-weight:600;\" data-v-4f810a51>strategic cooperation</span></div><div class=\"module_subTitle\" style=\"margin-top:80px;\" data-v-4f810a51> 移动互联网、物联网、国企、政府、交通等行业</div></div>", 1)
const _hoisted_103 = { class: "logo-container" }
const _hoisted_104 = ["src", "alt"]
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "zlhz_img cooperate" }, "期待与您合作", -1))
const _hoisted_106 = {
  key: 5,
  class: "content_box zlhz",
  style: {"position":"relative"}
}
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_19,
  style: {"width":"100%","height":"100%","position":"absolute","top":"0","left":"0"},
  alt: ""
}, null, -1))
const _hoisted_108 = { class: "home_container" }
const _hoisted_109 = /*#__PURE__*/_createStaticVNode("<div class=\"module_tit_box\" style=\"display:flex;justify-content:space-between;align-items:center;\" data-v-4f810a51><div class=\"module_title\" style=\"position:relative;margin-top:70px;\" data-v-4f810a51><img src=\"" + _imports_20 + "\" style=\"width:45px;height:62px;position:absolute;top:-39px;left:0px;\" alt=\"\" data-v-4f810a51><span style=\"position:absolute;z-index:1;display:block;font-size:18px;font-weight:600;color:#000 !important;\" data-v-4f810a51>战略合作</span><span style=\"display:block;font-size:14px;font-weight:600;color:#000 !important;opacity:0;\" data-v-4f810a51>战略合作</span><span style=\"display:block;color:#999 !important;font-size:14px;font-weight:600;\" data-v-4f810a51>strategic cooperation</span></div></div>", 1)
const _hoisted_110 = ["src"]
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "zlhz_img cooperate",
  style: {"height":"180px","line-height":"180px"}
}, "期待与您合作", -1))
const _hoisted_112 = {
  key: 6,
  class: "content_box zlhz",
  style: {"position":"relative"}
}
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_19,
  style: {"width":"100%","height":"100%","position":"absolute","top":"0","left":"0"},
  alt: ""
}, null, -1))
const _hoisted_114 = { class: "home_container" }
const _hoisted_115 = /*#__PURE__*/_createStaticVNode("<div class=\"module_tit_box\" style=\"display:flex;justify-content:space-between;align-items:center;\" data-v-4f810a51><div class=\"module_title\" style=\"position:relative;margin-top:100px;\" data-v-4f810a51><img src=\"" + _imports_20 + "\" style=\"width:80px;height:102px;position:absolute;top:-72px;left:0px;\" alt=\"\" data-v-4f810a51><span style=\"position:absolute;z-index:1;display:block;font-size:28px;font-weight:600;color:#000 !important;\" data-v-4f810a51>战略合作</span><span style=\"display:block;font-size:28px;font-weight:600;color:#000 !important;opacity:0;\" data-v-4f810a51>战略合作</span><span style=\"display:block;color:#999 !important;font-size:22px;font-weight:600;\" data-v-4f810a51>strategic cooperation</span></div></div>", 1)
const _hoisted_116 = ["src"]
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "zlhz_img cooperate",
  style: {"height":"180px","line-height":"180px"}
}, "期待与您合作", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_left_outlined = _resolveComponent("left-outlined")!
  const _component_right_outlined = _resolveComponent("right-outlined")!
  const _component_a_carousel = _resolveComponent("a-carousel")!
  const _component_FileTextOutlined = _resolveComponent("FileTextOutlined")!
  const _component_FormOutlined = _resolveComponent("FormOutlined")!
  const _component_AuditOutlined = _resolveComponent("AuditOutlined")!
  const _component_CodeOutlined = _resolveComponent("CodeOutlined")!
  const _component_FundProjectionScreenOutlined = _resolveComponent("FundProjectionScreenOutlined")!
  const _component_ToolOutlined = _resolveComponent("ToolOutlined")!
  const _component_a_step = _resolveComponent("a-step")!
  const _component_a_steps = _resolveComponent("a-steps")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_CustomerServiceOutlined = _resolveComponent("CustomerServiceOutlined")!
  const _component_a_float_button = _resolveComponent("a-float-button")!
  const _component_a_back_top = _resolveComponent("a-back-top")!
  const _component_a_float_button_group = _resolveComponent("a-float-button-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.states === 0)
      ? (_openBlock(), _createBlock(_component_a_carousel, {
          key: 0,
          "after-change": _ctx.onChange,
          autoplay: "",
          arrows: "",
          dotsClass: "custom-slick-dots"
        }, {
          prevArrow: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_left_outlined)
            ])
          ]),
          nextArrow: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_right_outlined)
            ])
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedBannerList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("a", _hoisted_4, [
                  _createElementVNode("img", {
                    src: item.image,
                    class: "d-block w-100",
                    alt: "..."
                  }, null, 8, _hoisted_5)
                ])
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["after-change"]))
      : _createCommentVNode("", true),
    (_ctx.states === 1)
      ? (_openBlock(), _createBlock(_component_a_carousel, {
          key: 1,
          "after-change": _ctx.onChange,
          autoplay: "",
          arrows: "",
          style: {"height":"30vh !important","background-color":"#0352AE"},
          dotsClass: "custom-slick-dots"
        }, {
          prevArrow: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_left_outlined)
            ])
          ]),
          nextArrow: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_right_outlined)
            ])
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedBannerList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                style: {"height":"calc(30vh - 60px) !important","background-color":"red"},
                key: index
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("a", _hoisted_9, [
                    _createElementVNode("img", {
                      src: item.image,
                      class: "d-block w-100",
                      alt: "..."
                    }, null, 8, _hoisted_10)
                  ])
                ])
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["after-change"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      (_ctx.states === 0 && _ctx.statestitle !== 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (item, index) => {
                    return _createElementVNode("div", {
                      key: index,
                      class: _normalizeClass(["image-box", { 'active': _ctx.activeIndex === index, 'expanded': _ctx.activeIndex === index }]),
                      onClick: ($event: any) => (_ctx.showFirstImage(index))
                    }, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("img", {
                          class: _normalizeClass(["small-img", { 'hidden': _ctx.activeIndex === index }]),
                          src: _ctx.getImageUrl('G', index + 1),
                          alt: ""
                        }, null, 10, _hoisted_20),
                        _createElementVNode("a", _hoisted_21, [
                          _createElementVNode("img", {
                            class: _normalizeClass(["large-img", { 'hidden': _ctx.activeIndex !== index }]),
                            src: _ctx.getImageUrl('Gr', index + 1),
                            alt: ""
                          }, null, 10, _hoisted_22)
                        ])
                      ])
                    ], 10, _hoisted_18)
                  }), 64))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.states === 1 && _ctx.statestitle !== 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
        : _createCommentVNode("", true),
      (_ctx.statestitle === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
        : _createCommentVNode("", true),
      (_ctx.states === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("div", _hoisted_34, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processSteps, (step, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "process-step",
                      key: index,
                      style: _normalizeStyle(step.style)
                    }, [
                      _createElementVNode("img", {
                        src: step.image,
                        alt: step.alt
                      }, null, 8, _hoisted_35)
                    ], 4))
                  }), 128))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.states === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _createElementVNode("div", _hoisted_39, [
                _createVNode(_component_a_steps, {
                  current: 7,
                  "label-placement": "vertical"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dzlcItems, (item, index) => {
                      return (_openBlock(), _createBlock(_component_a_step, { key: index }, {
                        title: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.title), 1)
                        ]),
                        description: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.description), 1)
                        ]),
                        icon: _withCtx(() => [
                          (index == 0)
                            ? (_openBlock(), _createBlock(_component_FileTextOutlined, { key: 0 }))
                            : (index == 1)
                              ? (_openBlock(), _createBlock(_component_FormOutlined, { key: 1 }))
                              : (index == 2)
                                ? (_openBlock(), _createBlock(_component_AuditOutlined, { key: 2 }))
                                : (index == 3)
                                  ? (_openBlock(), _createElementBlock("svg", {
                                      key: 3,
                                      xmlns: "http://www.w3.org/2000/svg",
                                      width: _ctx.settingWidth,
                                      height: _ctx.settingHeight,
                                      fill: "currentColor",
                                      class: "bi bi-pencil",
                                      viewBox: "0 0 16 16"
                                    }, _hoisted_42, 8, _hoisted_40))
                                  : (index == 4)
                                    ? (_openBlock(), _createBlock(_component_CodeOutlined, { key: 4 }))
                                    : (index == 5)
                                      ? (_openBlock(), _createBlock(_component_FundProjectionScreenOutlined, { key: 5 }))
                                      : (index == 6)
                                        ? (_openBlock(), _createBlock(_component_ToolOutlined, { key: 6 }))
                                        : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.states === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
          _hoisted_44,
          _createElementVNode("div", _hoisted_45, [
            (_ctx.states === 0 && _ctx.statestitle !== 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, _hoisted_49))
              : _createCommentVNode("", true),
            (_ctx.states === 1 && _ctx.statestitle !== 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, _hoisted_52))
              : _createCommentVNode("", true),
            (_ctx.statestitle === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_53, _hoisted_55))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_56, [
              _createVNode(_component_Swiper, {
                class: "xcdt_swiper",
                loop: true,
                slidesPerView: _ctx.slidesPerView,
                spaceBetween: 30,
                autoplay: { delay: 2500, disableOnInteraction: false }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SwiperSlide, null, {
                    default: _withCtx(() => [
                      _hoisted_57
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_SwiperSlide, null, {
                    default: _withCtx(() => [
                      _hoisted_58
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_SwiperSlide, null, {
                    default: _withCtx(() => [
                      _hoisted_59
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_SwiperSlide, null, {
                    default: _withCtx(() => [
                      _hoisted_60
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_SwiperSlide, null, {
                    default: _withCtx(() => [
                      _hoisted_61
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_SwiperSlide, null, {
                    default: _withCtx(() => [
                      _hoisted_62
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_SwiperSlide, null, {
                    default: _withCtx(() => [
                      _hoisted_63
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_SwiperSlide, null, {
                    default: _withCtx(() => [
                      _hoisted_64
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_SwiperSlide, null, {
                    default: _withCtx(() => [
                      _hoisted_65
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["slidesPerView"])
            ]),
            (_ctx.states === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                  _createVNode(_component_Swiper, {
                    class: "xcdt_swiper",
                    loop: true,
                    slidesPerView: _ctx.slidesPerView,
                    spaceBetween: 30,
                    autoplay: { delay: 5500, disableOnInteraction: false }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SwiperSlide, null, {
                        default: _withCtx(() => [
                          _hoisted_67
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_SwiperSlide, null, {
                        default: _withCtx(() => [
                          _hoisted_68
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_SwiperSlide, null, {
                        default: _withCtx(() => [
                          _hoisted_69
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_SwiperSlide, null, {
                        default: _withCtx(() => [
                          _hoisted_70
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_SwiperSlide, null, {
                        default: _withCtx(() => [
                          _hoisted_71
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_SwiperSlide, null, {
                        default: _withCtx(() => [
                          _hoisted_72
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_SwiperSlide, null, {
                        default: _withCtx(() => [
                          _hoisted_73
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_SwiperSlide, null, {
                        default: _withCtx(() => [
                          _hoisted_74
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_SwiperSlide, null, {
                        default: _withCtx(() => [
                          _hoisted_75
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["slidesPerView"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.states === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
          _hoisted_77,
          _createElementVNode("div", _hoisted_78, [
            (_ctx.states === 0 && _ctx.statestitle !== 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_79, _hoisted_82))
              : _createCommentVNode("", true),
            (_ctx.states === 1 && _ctx.statestitle !== 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_83, _hoisted_85))
              : _createCommentVNode("", true),
            (_ctx.statestitle === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_86, _hoisted_88))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_89, [
              _createVNode(_component_Swiper, {
                class: "xcdt_swiper",
                loop: true,
                slidesPerView: 3,
                spaceBetween: 30,
                autoplay: { delay: 5500, disableOnInteraction: false }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SwiperSlide, null, {
                    default: _withCtx(() => [
                      _hoisted_90
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_SwiperSlide, null, {
                    default: _withCtx(() => [
                      _hoisted_91
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_SwiperSlide, null, {
                    default: _withCtx(() => [
                      _hoisted_92
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_SwiperSlide, null, {
                    default: _withCtx(() => [
                      _hoisted_93
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_SwiperSlide, null, {
                    default: _withCtx(() => [
                      _hoisted_94
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_SwiperSlide, null, {
                    default: _withCtx(() => [
                      _hoisted_95
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_SwiperSlide, null, {
                    default: _withCtx(() => [
                      _hoisted_96
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_SwiperSlide, null, {
                    default: _withCtx(() => [
                      _hoisted_97
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_SwiperSlide, null, {
                    default: _withCtx(() => [
                      _hoisted_98
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.states === 0 && _ctx.statestitle !== 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
          _hoisted_100,
          _createElementVNode("div", _hoisted_101, [
            _hoisted_102,
            _createVNode(_component_a_row, {
              class: "zlhz_box",
              gutter: [25, 15]
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logoList, (item, index) => {
                  return (_openBlock(), _createBlock(_component_a_col, {
                    span: 4,
                    xl: 4,
                    lg: 4,
                    md: 4,
                    sm: 25,
                    xs: 25,
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_103, [
                        _createElementVNode("img", {
                          class: "zlhz_img",
                          src: item.companyLogo,
                          alt: item.companyName || '合作伙伴'
                        }, null, 8, _hoisted_104)
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                _createVNode(_component_a_col, {
                  span: 4,
                  xl: 4,
                  lg: 4,
                  md: 8,
                  sm: 10,
                  xs: 25
                }, {
                  default: _withCtx(() => [
                    _hoisted_105
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.states === 1 && _ctx.statestitle !== 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
          _hoisted_107,
          _createElementVNode("div", _hoisted_108, [
            _hoisted_109,
            _createVNode(_component_a_row, {
              class: "zlhz_box",
              gutter: [24, 0]
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logoList, (item, index) => {
                  return (_openBlock(), _createBlock(_component_a_col, {
                    span: 6,
                    xl: 6,
                    lg: 8,
                    md: 12,
                    xs: 24,
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        class: "zlhz_img",
                        style: {"height":"180px"},
                        src: item.companyLogo,
                        alt: ""
                      }, null, 8, _hoisted_110)
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                _createVNode(_component_a_col, {
                  span: 6,
                  xl: 6,
                  lg: 8,
                  md: 12,
                  xs: 24
                }, {
                  default: _withCtx(() => [
                    _hoisted_111
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.statestitle === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
          _hoisted_113,
          _createElementVNode("div", _hoisted_114, [
            _hoisted_115,
            _createVNode(_component_a_row, {
              class: "zlhz_box",
              gutter: [24, 0]
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logoList, (item, index) => {
                  return (_openBlock(), _createBlock(_component_a_col, {
                    span: 6,
                    xl: 6,
                    lg: 8,
                    md: 12,
                    xs: 24,
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        class: "zlhz_img",
                        style: {"height":"180px"},
                        src: item.companyLogo,
                        alt: ""
                      }, null, 8, _hoisted_116)
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                _createVNode(_component_a_col, {
                  span: 6,
                  xl: 6,
                  lg: 8,
                  md: 12,
                  xs: 24
                }, {
                  default: _withCtx(() => [
                    _hoisted_117
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_float_button_group, {
      shape: "square",
      style: { top: '50%', insetBlockEnd: 'unset' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_float_button, { href: "#footer" }, {
          icon: _withCtx(() => [
            _createVNode(_component_CustomerServiceOutlined)
          ]),
          _: 1
        }),
        _createVNode(_component_a_back_top, { "visibility-height": 100 })
      ]),
      _: 1
    })
  ], 512))
}